import { Client } from './Client';

export type AddClient = Omit<Client, 'id'>;

export const defaultAddClient: AddClient = {
    name: '',
    nip: '',
    email: '',
    phoneNumber: '',
    street: '',
    houseNumber: '',
    apartamentNumber: '',
    city: '',
    zipCode: '',
    country: '',
    notes: '',
};
